export class ListSnapshotRecipeEntriesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSnapshotRecipeEntriesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
